import React from 'react';
import cn from 'classnames';

import { isEmpty } from 'lodash';
import { useTranslation } from '@lt/localization';
import { Information as InformationIcon } from '@lt/components/icons-react/rebrand';
import Metapolicies from '../../../../components/Metapolicies';

import type { IAboutHotel } from './types';
import styles from './aboutHotel.module.css';

const AboutHotel = ({
  text,
  specialText,
  importantEvents,
  airports,
  metapolicies,
  isMobile,
  hotelName,
}: IAboutHotel) => {
  const { t } = useTranslation();
  const hasMetapolicies = !isEmpty(metapolicies);
  const hasAirpots = !isEmpty(airports);
  const hasContent = Boolean(text) || hasAirpots || hasMetapolicies;
  const hasImportantEvents = !isEmpty(importantEvents);

  if (!hasContent) return null;

  return (
    <div>
      {isMobile ? (
        <h3 className={styles.titleMobile}>{`${t(
          'hotel.aboutHotel.title',
        )} ${hotelName}`}</h3>
      ) : (
        <h2 className={styles.title}>{`${t(
          'hotel.aboutHotel.title',
        )} ${hotelName}`}</h2>
      )}
      {hasImportantEvents &&
        importantEvents.map((importantEvent) => (
          <div
            key={importantEvent.id}
            className={cn(styles.importantEvent, {
              [styles.mobileImportantEvent]: isMobile,
            })}
          >
            <InformationIcon className={styles.importantEventIcon} />
            <span className={cn(styles.importantEventTitle, styles.text)}>
              {importantEvent.title}
            </span>
            <span className={cn(styles.importantEventDescription, styles.text)}>
              {importantEvent.description}
            </span>
          </div>
        ))}
      {text ? (
        <p className={cn(styles.text, styles.description)}>{text}</p>
      ) : null}
      {specialText ? (
        <p
          className={cn(styles.specialDescription, {
            [styles.specialDescriptionMobile]: isMobile,
          })}
        >
          {specialText}
        </p>
      ) : null}

      {hasAirpots ? (
        <>
          <h5 className={cn(styles.text, styles.subTitle)}>
            {t('hotel.aboutHotel.airports')}
          </h5>
          <ul className={styles.list}>
            {airports?.map(({ name, distance }) => (
              <li
                className={styles.text}
                key={`${name}_${distance}`}
              >{`${name} — ${distance} км`}</li>
            ))}
          </ul>
        </>
      ) : null}

      {hasMetapolicies ? (
        <Metapolicies metapolicies={metapolicies} isMobile={isMobile} />
      ) : null}
    </div>
  );
};

export default AboutHotel;
